export default "__VITE_ASSET__B$n8EXLf__"